<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<mat-list>
  <ng-container *ngFor="let log of changelog.changelogData">
    <span matSubheader class="title">{{ log.version }}, released on {{ log.date }}</span>
    <mat-list-item *ngFor="let entry of log.entries">
      <mat-icon
        *ngIf="entry.type === 0"
        matTooltip="A new function has been added."
        matListItemIcon>
        add_circle_outline
      </mat-icon>
      <mat-icon *ngIf="entry.type === 1" matTooltip="A function has been removed." matListItemIcon>
        remove_circle_outline
      </mat-icon>
      <mat-icon *ngIf="entry.type === 2" matTooltip="Something has been modified." matListItemIcon>
        change_history
      </mat-icon>
      <span class="e">
        <p>{{ entry.text }}</p>
      </span>
    </mat-list-item>
    <mat-divider></mat-divider>
  </ng-container>
</mat-list>
